import { formatDetailValue } from "./detail-format";

export interface DetailFieldDefinition<K extends string> {
  readonly key: K;
  readonly label: string;
  /** Tratamento de apresentação do valor textual; sem ele o valor vai como recebido. */
  readonly format?: (value: string) => string;
  /** Abre linha no grid, para reproduzir o pareamento do protótipo. */
  readonly startsRow?: boolean;
}

/**
 * Campos da seção prontos para o `DetailField`, na ordem das definições: número no idioma da tela, texto pelo `format`
 * da definição e `null` como campo sem preenchimento: em branco (`null`) ou o `emptyText` da seção. Sem dados, nenhum
 * campo.
 */
export function buildDetailFields<K extends string>(
  dados: Readonly<Record<K, string | number | null>> | null | undefined,
  definitions: readonly DetailFieldDefinition<K>[],
  testId: string,
  emptyText?: string,
) {
  if (!dados) return [];

  return definitions.map(({ key, label, format, startsRow }) => {
    const value = formatDetailValue(dados[key], format) ?? emptyText ?? null;

    return { key, label, value, startsRow, testId: `${testId}-${key}` };
  });
}
